import { createReducer, on } from '@ngrx/store';
import { initialSharedState } from './shared.state';
import {
  setBenefitDocumentAutoPopupDisabled,
  setFilterCount,
} from './shared.actions';

export const sharedReducer = createReducer(
  initialSharedState,
  on(setFilterCount, (state, { filterCount }) => ({
    ...state,
    filterCount: filterCount,
  })),
  on(setBenefitDocumentAutoPopupDisabled, (state, { disabled }) => ({
    ...state,
    benefitDocumentAutoPopupDisabled: disabled,
  })),
);
